import React from 'react'

export const hats = (props) => {

    return(
        <div>hats Page</div>
    )


}